// extracted by mini-css-extract-plugin
export default {"container":"FilterWindow_container__uGsHQ","background":"FilterWindow_background__VlPka","main":"FilterWindow_main__fQDfQ"};